import shoes from "../images/shoe-3.webp";
import simpleWatch from "../images/simple_watch.webp";
import mobile from "../images/mobile.webp";
import smartWatch from "../images/smart_watch.webp";

export const flashDeal = [
  {
    id: 1,
    cardImg: shoes,
    title: "NikeCourt Zoom Vapor Cage",
    prizeCurrent: "154.56",
    prizeClose: "$168.00",
    off: "25%",
    like: false,
  },
  {
    id: 2,
    cardImg: simpleWatch,
    title: "classic rolex watch",
    prizeCurrent: "297.50",
    prizeClose: "$350.00",
    off: "15%",
    like: false,
  },
  {
    id: 3,
    cardImg: mobile,
    title: "iphone 13 pro max",
    prizeCurrent: "108.00",
    prizeClose: "$150.00",
    off: "28%",
    like: false,
  },
  {
    id: 4,
    cardImg: smartWatch,
    title: "mi led smart watch",
    prizeCurrent: "142.20",
    prizeClose: "$180.00",
    off: "21%",
    like: false,
  },
  {
    id: 1,
    cardImg: shoes,
    title: "NikeCourt Zoom Vapor Cage",
    prizeCurrent: "154.56",
    prizeClose: "$168.00",
    off: "25%",
    like: false,
  },
  {
    id: 2,
    cardImg: simpleWatch,
    title: "classic rolex watch",
    prizeCurrent: "297.50",
    prizeClose: "$350.00",
    off: "15%",
    like: false,
  },
  {
    id: 3,
    cardImg: mobile,
    title: "iphone 13 pro max",
    prizeCurrent: "108.00",
    prizeClose: "$150.00",
    off: "28%",
    like: false,
  },
  {
    id: 4,
    cardImg: smartWatch,
    title: "mi led smart watch",
    prizeCurrent: "142.20",
    prizeClose: "$180.00",
    off: "21%",
    like: false,
  },
];
